import moment from "moment";
import { ProductDetail } from "../interface";
import atoms from "../../../atoms";
import { currencySymbol, priceTagFormatter } from "../../../../constants/utils";

interface ColumnProductDetail extends ProductDetail {
  action: JSX.Element;
  cover_photo: JSX.Element;
}

interface Column<T> {
  name: string;
  selector?: (row: T) => JSX.Element | string | number | boolean;
  cell?: (row: T) => JSX.Element;
  sortable?: boolean;
  minWidth?: string;
  center?: boolean;
}

const { CustomImages } = atoms;

// INFO:- table columns for pending product list
export const Pending_Product_Columns: Column<ColumnProductDetail>[] = [
  {
    name: "Brand",
    selector: (row) => row.brand.brand_name,
    sortable: true,
    minWidth: "120px",
  },
  {
    name: "Date",
    selector: (row) =>
      row.updatedAt ? moment(row.updatedAt).format("DD/MM/YYYY") : "-",
  },
  {
    name: "Product ID",
    selector: (row) => row.product_id_display,
    minWidth: "150px",
  },
  {
    name: "Cover Photo",
    cell: (row) => (
      <CustomImages
        src={row.images?.length ? row.images[0] : ""}
        imageHeight={"0px"}
      />
    ),
    center: true,
  },
  {
    name: "Model No.",
    selector: (row) => (row.modal_number ? row.modal_number : "-"),
  },
  { name: "Product Type", selector: (row) => row.product_type.name },
  {
    name: `Product SRP (${currencySymbol()})`,
    selector: (row) =>
      row.product_srp !== null ? priceTagFormatter(row.product_srp) : "-",
  },
  {
    name: "Updated By",
    selector: (row) => row.updated_by || "",
    minWidth: "150px",
  },
  { name: "Status", selector: (row) => row.isActive },
  { name: "Verification Status", selector: (row) => row.verification_status },
  { name: "Action", selector: (row) => row.action },
];
// end

// INFO:- table columns for pending product list in case contact lens
export const Pending_Product_Columns_ContactLens: Column<ColumnProductDetail>[] =
  [
    {
      name: "Brand",
      selector: (row: ProductDetail) => row.brand.brand_name,
      sortable: true,
      minWidth: "120px",
    },
    {
      name: "Date",
      selector: (row: any) =>
        row?.updatedAt ? moment(row?.updatedAt).format("DD/MM/YYYY") : "-",
    },
    {
      name: "Product ID",
      selector: (row: ProductDetail) => `${row.product_id_display}`,
      minWidth: "150px",
    },
    {
      name: "Cover Photo",
      cell: (row: any) => (
        <CustomImages
          src={row?.images?.length > 0 && row?.images[0]}
          imageHeight={"0px"}
        />
      ),
      center: true,
    },
    {
      name: "Product Type",
      selector: (row: ProductDetail) => row.product_type.name,
    },
    {
      name: `Product SRP (${currencySymbol()})`,
      selector: (row: ProductDetail) =>
        `${row.product_srp !== null
          ? priceTagFormatter(row.product_srp)
          : "-"
        }`,
    },
    { name: "Status", selector: (row: ProductDetail) => row.isActive },
    {
      name: "Verification Status",
      selector: (row: ProductDetail) => row.verification_status,
    },
    { name: "Action", selector: (row: any) => row.action },
  ];
// end
